import React from 'react';
import classNames from 'classnames';
import { Drawer as MuiDrawer } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import { isPortrait } from '../helpers/mobile';

const Drawer = ({ classes, children, isOpen, onClose }) => {
  const mobile = isPortrait();

  return (
    <MuiDrawer
      open={isOpen}
      onClose={onClose}
      variant={!mobile ? 'permanent' : 'temporary'}
      className={classNames(
        classes.drawer,
        !mobile && {
          [classes.drawerOpen]: isOpen,
          [classes.drawerClose]: !isOpen,
        }
      )}
      classes={{
        paper: classNames(
          classes.drawerPaper,
          !mobile && {
            [classes.drawerOpen]: isOpen,
            [classes.drawerClose]: !isOpen,
          }
        ),
      }}
    >
      {children}
    </MuiDrawer>
  );
};

const drawerWidth = 240;

const styles = theme => ({
  drawer: {
    display: 'flex',
    width: drawerWidth,
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  drawerPaper: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    position: 'static',
  },
  drawerOpen: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    width: drawerWidth,
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    width: 0,
  },
});

export default withStyles(styles)(Drawer);
